<template>
  <v-expansion-panels
    v-model="panel"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        {{ title }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-text-field
            v-model="search"
            color="third"
            append-icon="mdi-magnify"
            :label="title"
            :placeholder="title"
            single-line
            hide-details
            class="pb-4 pt-0 mt-0 px-3"
            @click.stop
          />
          <v-data-table
            v-model="selectedItem"
            :search="search"
            :items="slicedContent"
            :hide-default-footer="true"
            :hide-default-header="true"
            :items-per-page="-1"
            item-key="value"
            item-text="label"
            :headers="headers"
            :height="!expandList ? 250 : slicedContent.length * 48"
            show-select
            :custom-filter="filterDataTableSession"
            :loading="loading"
            checkbox-color="third"
            @click:row="rowClick"
            @input="selectItem"
          >
            <template #item.name="{ item }">
              {{ item.label }}
            </template>
            <template #item.count="{ item }">
              <v-avatar
                v-if="item.count"
                color="third"
                size="24"
              >
                <span class="white--text"> {{ item.count }}</span>
              </v-avatar>
            </template>
          </v-data-table>
          <div v-if="tableItems && tableItems.length > 5">
            <span
              class="font-weight-bold pointer"
              @click="expandList = !expandList"
            >{{ !expandList ? 'Voir tous' : 'Voir moins' }}</span>
          </div>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const search = ref(null);

    const expandList = ref(false);

    const selectedItem = ref([]);

    const panel = ref([]);

    const headers = [
      { text: '', value: 'name' },
      { text: '', value: 'count' }
    ];

    const tableItems = computed(() => props.items);

    const manageSessionTypeItemsQuantity = computed(() => (expandList.value ? 9999999 : 5));

    const slicedContent = computed(() => (tableItems.value || []).slice(0, manageSessionTypeItemsQuantity.value));

    const filterDataTableSession = (value, searchValue, item) => item.label.toLowerCase().includes(searchValue.toLowerCase());

    const rowClick = (item, row, event) => {
      event.stopPropagation();
      row.select(!row.isSelected);
    };

    const selectItem = tableItem => {
      context.emit('updateContent', tableItem);
    };

    return { search, expandList, slicedContent, tableItems, filterDataTableSession, headers, rowClick, selectItem, selectedItem, panel };
  }
};

</script>
